import { Box, SxProps, TableCell, TableRow } from '@mui/material';
import { FunctionComponent } from 'react';
import { Loader } from '../../../../ui/components';
import { ChartSettings } from '../../../chart-settings/model';
import { useSlaMetricsMeasurementApiGet } from '../../hooks';
import { SlaMonitoredClassOfServiceViewModel } from '../../model';
import { SlaStatisticsTableChart } from '../SlaStatisticsTableChart/SlaStatisticsTableChart';

interface Props {
  classOfService: SlaMonitoredClassOfServiceViewModel;
  chartSettings: ChartSettings;
  columnsQuantity: number;
  customerId: number;
}

export const SlaStatisticsTableRow: FunctionComponent<Props> = (
  { classOfService, columnsQuantity, chartSettings, customerId },
) => {
  const {
    measurement,
    isFetched,
    isFetching,
  } = useSlaMetricsMeasurementApiGet(
    customerId,
    classOfService.itemId,
    classOfService.cosId,
    chartSettings,
    'table',
  );
  const containerSx: SxProps = { display: 'flex' };
  const chartSx: SxProps = { width: '33%', padding: 2, borderRadius: '0.5rem' };

  return <TableRow style={{ background: '#EFF6FF' }} className={'MuiTableRowExpanded'}>
  <TableCell colSpan={columnsQuantity + 2}>
    {isFetching && <Box sx={{
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}><Loader loading={true} /></Box>}
    {!isFetching && isFetched && <Box sx={containerSx} data-testid={'charts'}>
      {measurement && <>
        <Box sx={chartSx}>
          <SlaStatisticsTableChart
            classOfService={classOfService}
            chartData={measurement}
            metric='delay'
            unit='millisecond'
            chartSettings={chartSettings}
            customerId={customerId}
          />
        </Box>
        <Box sx={chartSx}>
          <SlaStatisticsTableChart
            classOfService={classOfService}
            chartData={measurement}
            metric='jitter'
            unit='millisecond'
            chartSettings={chartSettings}
            customerId={customerId}
          />
        </Box>
        <Box sx={chartSx}>
          <SlaStatisticsTableChart
            classOfService={classOfService}
            chartData={measurement}
            metric='lossRatio'
            unit='percent'
            chartSettings={chartSettings}
            customerId={customerId}
          />
        </Box>
      </>}
    </Box>}
  </TableCell>
 </TableRow>;
};